import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getCurrentUser } from "@aws-amplify/auth";

const ProtectedRoute = ({ isAuthPage }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser();
        
        setIsAuthenticated(!!user); // Set to true if user exists
      } catch {
        setIsAuthenticated(false); // Set to false if no user
      }
    };
    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    // Add a loading spinner or placeholder while checking auth state
    return <div>Loading...</div>;
  }

  if (isAuthenticated && isAuthPage) {
    // If user is authenticated and trying to access an auth page, redirect to dashboard
    // COMMENTED OUT: Pricing page redirect - now going directly to dashboard
    // return <Navigate to="/pricing" />;
    return <Navigate to="/dashboard/home" />;
  }

  if (!isAuthenticated && !isAuthPage) {
    // If user is not authenticated and trying to access a protected page, redirect to login
    return <Navigate to="/login" />;
  }

  // Render the children components (e.g., LoginPage, PricingPlans)
  return <Outlet />;
};
export default ProtectedRoute;